import { Component, OnInit } from '@angular/core';
import { Product } from '../models/products.models';
import { BaseComponent } from '../../_shared/base.component';
import { Router } from '@angular/router';
import { ProductsService } from '../products.service';
import { MessageService } from '../../layout/message/message.service';
import { ConfirmationService } from 'primeng/api';

@Component({
	selector: 'pm-products',
	templateUrl: './products.component.html',
	styleUrls: ['./products.component.css'],
})
export class ProductsComponent extends BaseComponent implements OnInit {
	reportStartDate: string = "";
	reportWeeksToGo: number = 5;
	products: Product[] = null;
	payPortalProducts: Product[] = null;
	constructor(
		router: Router,
		message: MessageService,
		private confirmationService: ConfirmationService,
		private productsService: ProductsService
	) {
		super(router, message);
	}
	ngOnInit() {
		this.productsService.getProductsList().subscribe(
			rsp => {
				this.products = rsp.Data.filter(
					(x: Product) => x.PayPortal === false)
					.map((x: Product) => {
						if (x.BudgetCode.length > 5) {
							x.BudgetCode = '-' + x.BudgetCode.substr(x.BudgetCode.length - 4, 4);
						}
						if (x.Name.length > 40) {
							x.Name = x.Name.substr(0, 35);
						}
						if (x.TinyUrl != null && x.TinyUrl.includes('.com')) {
								x.TinyUrl = x.TinyUrl.split('.com')[1];
						}
						return x;
					});
					this.payPortalProducts = rsp.Data.filter( (x: Product) => x.PayPortal === true); // to use later
			},
			err => {
				this.showErrorMessage('Error', JSON.stringify(err.error));
				this.products = [];
				this.payPortalProducts = [];
			},
		);
	}

	addProduct() {
		this._router.navigate(['/products', 0]);
	}

	logout() {
		this._router.navigate(['/logout']);
	}

	generateReport(event: any) {
		this.confirmationService.confirm({
			header: 'Confirm Report',
			message: `Sending report to accounting email on file. This will take a few minutes.`,
			acceptLabel: 'Confirm',
			rejectLabel: 'Cancel',
			accept: () => {
				event.srcElement.innerHTML = 'Generating Report';
				event.srcElement.disabled = true;
				console.log(this.reportStartDate);
				console.log(this.reportWeeksToGo);
				// this.productsService.initiateTransactionMonthReport(1) // current set to get 1 month back.
				var stringDate = this.reportStartDate['month'] + "/" + this.reportStartDate['day'] + "/" + this.reportStartDate['year'];
				this.productsService.initiateCustomTransactionReport(stringDate, this.reportWeeksToGo) // current set to get 1 month back.
					.subscribe(rsp => {
						if (!rsp.HasError) {
							this.showSuccessMessage(`Email Sent with ${rsp.Data} records`);
						} else {
							this.showErrorMessage(`Server error: ${rsp.Message}`);
						}
						event.srcElement.innerHTML = 'Initiate Report';
						event.srcElement.disabled = false;
					}, err => {
						this.showErrorMessage(`Server error`);
						console.log(`Error: ${JSON.stringify(err.error)}`);
						event.srcElement.innerHTML = 'Initiate Report';
						event.srcElement.disabled = false;
					});
				this.showInfoMessage('Report Request sent.');
			},
		});
	}

	viewProduct(id: number) {
		this._router.navigate(['/products', id]);
	}

	copyToClipboard(url: string) {
		url = 'http://tinyurl.com' + url;
		if (this.productsService.copyToClipboardUtil(document, url)) {
			this.showSuccessMessage('Copied!', url);
		} else {
			this.showErrorMessage('Error', 'No tiny url found');
		}
	}

	closeProduct(p: Product) {
		p.IsClosed = !p.IsClosed;
		this.productsService.saveProduct(p).subscribe(_ => {
			this.showSuccessMessage('Status Change',
				p.IsClosed ? `${p.Name} is now closed` : `${p.Name} is re-opened`);
		});
	}
	confirmDelete(p: Product) {
		this.confirmationService.confirm({
				header: 'Confirm Delete',
				message: `Are you sure you want to delete "${p.Name}".`,
				acceptLabel: 'Confirm',
				rejectLabel: 'Cancel',
				accept: () => {
						this.deleteProduct(p);
				},
		});
	}
	deleteProduct(p: Product) {
		this.productsService.deleteProduct(p.Id).subscribe(rsp => {
			const {Error} = rsp;
			if (Error) {
				this.showErrorMessage('Error', Error);
			} else {
				const index = this.products.findIndex(x => x.Id === p.Id);
				this.products.splice(index, 1);
				this.showSuccessMessage('Success', `${p.Name} deleted.`);
			}
		});
	}
}
